import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
@Injectable()
export class ReleaseOrderService {

    private api_url_get_current_reference_release_order = './api/server.php?cmd=GET_CURRENT_REFERENCE_RELEASE_ORDER';
    private api_url_reset_pannier_release_order = './api/server.php?cmd=RESET_PANNIER_RELEASE_ORDER';
    private api_url_validate_release_order = './api/server.php?cmd=VALIDATE_RELEASE_ORDER';
    private api_url_get_clients_list = './api/server.php?cmd=GET_CLIENTS_LIST';

    constructor(private http: Http) {}

    GetCurrentReferenceReleaseOrder(motif: string): Promise<Object> {
        return this.http.get(this.api_url_get_current_reference_release_order
            + '&motif=' + motif)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ResetPannier(): Promise<Object> {
        return this.http.get(this.api_url_reset_pannier_release_order)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateReleaseOrder(transaction_name: string, transaction_date: string, transaction_reference: string, transaction_date_delivery: string, transaction_destination: string, transaction_motif: string, remark: string, transaction_antecedent: string): Promise<Object> {
        return this.http.get(this.api_url_validate_release_order
            + '&transaction_name=' + transaction_name
            + '&transaction_date=' + transaction_date
            + '&transaction_reference=' + transaction_reference
            + '&transaction_date_delivery=' + transaction_date_delivery
            + '&transaction_destination=' + transaction_destination
            + '&transaction_motif=' + transaction_motif
            + '&remark=' + remark
            + '&transaction_antecedent=' + transaction_antecedent
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetClientsList(): Promise<Object> {
        return this.http.get(this.api_url_get_clients_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/release-order.service.ts